import React from "react";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import "../Projects/project.css";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import ProjectCard from "./ProjectCard";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import notes_cover from "../../Assets/notes_cover_1.jpg";
// import Aquatic from "../../Assets/aquatic.jpg";
// import tindog from "../../Assets/tindog.jpg";
// import dashboard from "../../Assets/dashboard.jpg";
// import portfolio_thumbnail from "../../Assets/portfolio_thumbnail.jpg";
// import calci from "../../Assets/calci.jpg";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

function Projects() {
  return (
    <div className="root_container">
      <div className="prj_header_container">
        <Link className="h_btn_cont" to="/">
          <button type="button" className="return_home-btn">
            <p>Return</p>
            <HomeRoundedIcon className="home_icon" />
          </button>
        </Link>

        <h1>
          Recent <span>Projects</span>
        </h1>
      </div>

      <div className="prj_container">
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
          }}
          pagination={{ el: ".swiper-pagination", clickable: true }}
          navigation={{
            nextEl: ".nxt-btn",
            prevEl: ".prev-btn",
            clickable: true,
          }}
          modules={[EffectCoverflow, Pagination, Navigation]}
          className="swiper_container"
        >
          <SwiperSlide>
            <ProjectCard
              name="OS hardening WebApp Dashboard"
              info="Dashboard Design: OS Hardening Frontend with ReactJS"
              link="https://youtu.be/xjVl58k-qMY"
              image="/Assets/dashboard.jpg"
            />
          </SwiperSlide>
          <SwiperSlide>
            <ProjectCard
              name="Notes App"
              info="lorem lorem lijkm dkjjij sijlk"
              // link="lasdlkasmfkln"
              image="/Assets/notes_cover_1.jpg"
            />
          </SwiperSlide>
          <SwiperSlide>
            <ProjectCard
              name="Project_2"
              info="This is the info of the second projstec"
              // link="lasdlkasmfkln"
              image="/Assets/aquatic.jpg"
            />
          </SwiperSlide>
         
          <SwiperSlide>
            <ProjectCard
              name="Calculator"
              info="A scientific Calculator using HTML, CSS, JS"
              link="https://glennex.github.io/scientific_calc/"
              image="/Assets/calci.jpg"
            />
          </SwiperSlide>
           <SwiperSlide>
            <ProjectCard
              name="Tin Dog"
              info="A code along HTML, CSS, Bootstrap project from Udemy"
              link="https://glennex.github.io/tindog_web/"
              image="/Assets/tindog.jpg"
            />
          </SwiperSlide>
            <SwiperSlide>
            <ProjectCard
              name="Amaan Portfolio Website"
              info="My portfolio website (ongoing) using React js"
              link="https://amaanfolio.netlify.app/"
              image="/Assets/portfolio_thumbnail.jpg"
            />
          </SwiperSlide>
        </Swiper>

        <div className="slider-controler">
          <div className="swiper-btn-next slider-arrow"></div>
          <div className="swiper-pagination"></div>
        </div>

        <div className="slider-btn_container">
          <button className="prev-btn navigate-btn">
            <div className="text-n-p">Prev</div>
          </button>
          <button className="nxt-btn navigate-btn">
            <div className="text-n-n">Next</div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Projects;
